import { genericGet } from "../../../services/api.service";
import { EntityConfig } from "../../..";

export const NotasCreditoClientesTableConfigs : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
      },
    {
      id: 'code',
      label: 'Nota de Crédito',
      type: 'text',
      filterable: true
    },
    {
      id: 'date',
      label: 'Data',
      type: 'date',
      filterable: true,
    },
    {
      id: 'client',
      label: 'Cliente',
      type: 'select',
      filterable: true,
      options: {
        name: 'Cliente',
        route: 'client',
        value: 'id',
        label: 'name',
        getter: ()=>genericGet('/findByFilter/clientes'),
        searcheable: true
      }
    },
    {
        id: 'value',
        label: 'Valor',
        type: 'number',
        displayInfo: 'currency'
    },
    {
      id: 'faturacaoADescontar',
      label: 'Fatura a descontar',
      type: 'select',
      filterable: true,
      options: {
        name: 'Fatura',
        route: 'faturacaoClientes',
        value: 'id',
        label: 'code',
        displayInfo: [{name: 'Fatura', label: 'code'}, {name: 'Valor', label: 'value', type: 'currency'}],
        // getter: ()=>genericGet('/findByFilter/faturacao-clientes'),
        triggeredGetter: (i : number)=>genericGet(`/faturacao-clientes/unpaid/${i}`), // function to trigger according to other form parameter
        triggerParam: 'client', // Form parameter used to build getterfunction
        searcheable: true

      }
    },
    {
      id: 'used',
      label: 'Usada',
      type: 'boolean',
      filterable: true,

  }
  ];
  